var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclusiveTagIcnWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_9)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1316_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.147 84.821c38.741 37.667 73.439 64.811 77.5 60.629 4.061-4.182-24.053-38.107-62.794-75.774-38.74-37.666-73.439-64.81-77.5-60.628-4.06 4.182 24.053 38.107 62.794 75.773z",
    fill: "#ED1C24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.052 0h154.902v155L70.985 71.745.052 0z",
    fill: "#000",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.035 29.843c-7.971-7.578-13.052-12.282-13.052-12.282s-5.088 4.704-13.047 12.282c-4.204 4.006-13.658 13.939-13.658 23.821-.002 2.603.89 5.134 2.54 7.208 1.65 2.073 3.969 3.575 6.599 4.275 2.63.7 5.43.559 7.969-.4 2.538-.96 4.678-2.684 6.091-4.911.119-.141.27-.256.44-.336a1.37 1.37 0 01.548-.13c.64 0 1.227.433 1.163.964-.483 3.551-2.576 12.304-10.849 15.257h24.419c-8.268-2.953-10.361-11.705-10.843-15.257-.07-.553.517-.964 1.163-.964.189.007.374.052.544.132.169.08.319.194.438.334 1.414 2.224 3.553 3.947 6.091 4.904a13.084 13.084 0 007.964.397c2.629-.7 4.945-2.2 6.595-4.271 1.65-2.072 2.543-4.6 2.543-7.202 0-9.871-9.454-19.804-13.652-23.82",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.989 30.542l3.42 10.21h11.075l-8.957 6.31 3.425 10.204-8.963-6.304-8.958 6.304 3.42-10.204-8.963-6.31h11.087l3.414-10.21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.934 12.425l87.972 88.966",
    stroke: "url(#paint0_linear_1316_9)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1316_9",
    x1: 11.498,
    y1: 12.543,
    x2: 144.571,
    y2: 144.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h155v155H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1316_9",
    x: -18.037,
    y: -16.377,
    width: 191.074,
    height: 187.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_1316_9"
  })))));
}
SvgExclusiveTagIcnWide.displayName = 'ExclusiveTagIcnWide';
export default SvgExclusiveTagIcnWide;